import { Controller } from "@hotwired/stimulus"

// Lightweight live search → updates a turbo-frame's `src` directly,
// the same pattern the All Phases nav uses. No form submission, no
// Turbo Drive form intercept — just a debounced URL update so the
// typing experience stays native (caret/focus never move).
//
// Usage:
//   <div data-controller="frame-search"
//        data-frame-search-frame-value="results_frame_id"
//        data-frame-search-base-value="<%= some_path %>"
//        data-frame-search-extra-value='<%= { tab: @tab, kind: params[:kind] }.compact_blank.to_json %>'>
//     <input type="search"
//            data-action="input->frame-search#search search->frame-search#search">
//   </div>
//
// `extra-value` is parsed as JSON and merged into the query string
// every search so server-side filters carry through.
export default class extends Controller {
  static values = {
    frame: String,
    base: String,
    delay: { type: Number, default: 250 },
    paramName: { type: String, default: "q" },
    extra: { type: Object, default: {} }
  }

  search(e) {
    if (this._timer) clearTimeout(this._timer)
    const value = e.target.value
    this._timer = setTimeout(() => this._update(value), this.delayValue)
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  _update(value) {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return
    const url = new URL(this.baseValue, window.location.origin)
    Object.entries(this.extraValue || {}).forEach(([k, v]) => {
      if (v != null && v !== "") url.searchParams.set(k, v)
    })
    if (value && value.length > 0) {
      url.searchParams.set(this.paramNameValue, value)
    }
    frame.src = url.toString()
  }
}
